import React, { Component } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button
} from 'reactstrap';
import Search from './core_insight_prefectures/Search.js';
import Map from './core_insight_prefectures/Map.js';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUsers,
  faYenSign,
  faHome,
  faShoppingCart
} from '@fortawesome/free-solid-svg-icons';
import { faCircle } from '@fortawesome/free-regular-svg-icons';
import NotesModal from '../common/NotesModal.js';

class CoreInsightPrefectures extends Component {
  constructor(props) {
    super(props);
    this.state = {
      coreInsight: null,
      prefecture: null,
      intervals: null,
      responseType: null,
      coreInsightValues: null
    };
  }

  componentDidMount() {
    const { coreInsightId } = this.props;

    fetch('/api/core_insights/' + coreInsightId).then((resp) => resp.json())
      .then((respJson) => {
        this.setState({ coreInsight: respJson }, () => {
          this.getPrefectureData();
        });
      });
  }

  getPrefectureData() {
    const { coreInsight } = this.state;

    if (coreInsight.endpoint) {
      fetch(coreInsight.endpoint).then((resp) => resp.json())
        .then((respJson) => {
          if (respJson.type === 'interval') {
            this.setState({
              responseType: respJson.type,
              intervals: respJson.intervals,
              coreInsightValues: respJson.data
            });
          } else {
            this.setState({
              responseType: respJson.type,
              coreInsightValues: respJson.data
            });
          }
        });
    }
  }

  getCategoryIcon(category) {
    let icon = null;

    switch (category) {
      case 'Demographic': icon = faUsers;
        break;
      case 'Economic': icon = faYenSign;
        break;
      case 'Retail': icon = faShoppingCart;
        break;
      case 'Social & Wellness': icon = faHome;
        break;
      default: break;
    }

    return icon;
  }

  render() {
    const { coreInsight, responseType, intervals, coreInsightValues } = this.state;
    const { coreInsightId } = this.props;

    return (
      <Container fluid={true} className="sl-view-shell">
        <div className="sl-view-hero">
          <div>
            <div className="sl-view-kicker">Core Insights</div>
            <h1 className="sl-view-title">Insight Coverage Map</h1>
            <p className="sl-view-subtitle">Review distribution and search prefectures that match this insight profile.</p>
          </div>
          <span className="sl-view-meta">Insight Drill-In</span>
        </div>

        <Row className="sl-grid-gap">
          <Col md="6">
            <Card className="mb-3 sl-panel">
              <CardHeader className="sl-panel-header">
                {coreInsight && <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <span className="fa-layers fa-fw mr-2">
                      <FontAwesomeIcon icon={faCircle} transform="grow-10" />
                      <FontAwesomeIcon
                        icon={this.getCategoryIcon(coreInsight.category)}
                        transform="shrink-4" />
                    </span>
                    {coreInsight.category}
                    <br/>
                    <h5 className="mt-1 mb-0">{coreInsight.name}</h5>
                  </div>
                  {(coreInsight.notes_body || coreInsight.notes_title) &&
                    <NotesModal
                      title={coreInsight.notes_title}
                      body={coreInsight.notes_body} />}
                </div>}
              </CardHeader>
              <CardBody>{coreInsight ? coreInsight.content : null}</CardBody>
            </Card>
            <Map
              coreInsightId={coreInsightId}
              responseType={responseType}
              intervals={intervals}
              coreInsightValues={coreInsightValues} />
            <Button color="primary" tag="a" href="/core_insights/index" className="sl-inline-action" outline>
              Back to Core Insights
            </Button>
          </Col>
          <Col md="6">
            <Search
              coreInsightId={coreInsightId}
              coreInsight={coreInsight}
              responseType={responseType} />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default CoreInsightPrefectures;
